








































import SmallText from "@/common/components/atoms/SmallText.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import ReplaceAmpm from "@/general/mixins/replaceAmpm";
import { Prop, Vue, Component } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import * as dayjs from "dayjs";
import * as isLeapYear from "dayjs/plugin/isLeapYear"; // import plugin;
import "dayjs/locale/ja"; // import locale
import utc from "dayjs/plugin/utc";
import { mixins } from "vue-class-component";
import globals from "@/general/store/modules/globals";

dayjs.extend(utc);

@Component({
  components: {
    SmallText,
    IconUserImage
  }
})
export default class J05ChatScreenPanelMessage extends mixins(ReplaceAmpm) {
  @Prop({ type: Object, required: true }) chatData!: any;
  @Prop({ type: Boolean, required: true }) isSp!: boolean;
  @Prop({ type: Boolean, required: true }) isYouSent!: boolean;
  @Prop({ type: Object, required: true }) classNameDirection!: any;

  classNameBase = {
    rootElement: "p-the-j05-chat-screen-panel-message",
    col: "p-the-j05-chat-screen-panel-message__col",
    message: "p-the-j05-chat-screen-panel-message__message"
  };

  get chatLog() {
    return this.chatData.chatLog;
  }

  get id() {
    return this.chatData.id;
  }

  get name() {
    return this.chatData.name;
  }

  get icon() {
    return this.chatData.icon.medium;
  }

  get time() {
    const date = this.chatData.date;
    const formatted = dayjs
      .utc(date)
      .locale("ja")
      .format("Ah:mm");

    return this.replaceAmpmInit(formatted);
  }

  get message() {
    return this.chatData.message;
  }

  get image() {
    return this.chatData.image;
  }

  get unread() {
    return this.chatData.unread;
  }

  get key() {
    return this.chatData.key;
  }

  get nextItemTime() {
    const key = this.chatData.key;
    const chatLog = this.chatData.chatLog;
    const lastKey = chatLog.length - 1;
    return key < lastKey ? chatLog[key + 1].time : "";
  }

  get prevItemIsSameId() {
    const key = this.chatData.key;
    const chatLog = this.chatData.chatLog;
    const prevItemId = key > 0 ? chatLog[key - 1].id : "";
    return prevItemId === this.chatData.id;
  }

  get timeTextFontSize() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    return isSpScreenWidth ? 11 : 14;
  }
}
